// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"_wJZSdS36","badge":"_k5fXsHI_","active":"_ynVnmLCm","inactive":"_MQDSjn0S"};